<template>
  <li class="pricing__table--item" :class="{ 'table-item-small': hasManyRows }">
    <!-- todo ver si mostramos alias o style id, por ahora no los productos de IP no tienen alias -->
    <p class="code">{{ row && row.styleId }}</p>
    <p class="gender">{{ row.gender }}</p>
    <p class="size" :class="{ 'long-size-row': hasLongSizes }">
      {{ row.sizes }}
    </p>

    <!-- Prices -->
    <div
      class="price"
      v-if="showProjectPrices"
      :class="{ editable: showEditablePrices }"
    >
      <span class="dollar-sign">$</span>
      <!-- Normal price -->
      <p v-if="!showEditablePrices">{{ rowPrice }}</p>
      <!-- Editable price -->
      <input
        v-if="showEditablePrices"
        :disabled="loading || isProductSublimated"
        class="price"
        :value="rowPrice"
        type="number"
        step="0.05"
        min="0"
        @input="debounceUpdate($event.target.value)"
      />

      <div class="tooltip-container" v-if="isEditMode && showProjectPrices">
        <img
          src="@/assets/icons/ui/information-circle-outline.svg"
          alt="info icon"
        />
        <div class="tooltip-info">Only you can see this</div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { debounce } from "debounce";
import { cloneDeep } from "lodash";

export default {
  name: "GridRow",
  computed: {
    ...mapGetters("project", [
      "getCustomerPrice",
      "isCreateMode",
      "isEditMode",
      "isPlaybook",
      "isSnapsheet",
      "showProjectPrices",
    ]),
    ...mapGetters("playbook", ["getPlaybookCards"]),
    ...mapState("auth", ["dealerMode"]),

    hasLongSizes() {
      return this.row?.sizes?.length > 7;
    },

    dealerPrice() {
      const price = this.product?.dealerPrice || this.product?.dealer_price;
      return price ? Number(price) : null;
    },

    rowPrice() {
      const price = this.row.customPrice || this.row.price;
      return price && Number(price).toFixed(2);
    },

    showEditablePrices() {
      return (
        (this.dealerMode &&
          (this.isEditMode || this.isCreateMode) &&
          this.productIsEditable) ||
        this.isPlaceholderPage
      );
    },
  },

  methods: {
    ...mapActions("snapsheet", ["updateProductPrice"]),
    ...mapActions("playbook", ["updatePlaybookItem"]),
    ...mapActions("project", [
      "triggerLoading",
      "endLoading",
      "showSaveIndicator",
    ]),
    debounceUpdate: debounce(async function (newPrice) {
      //Update in DB
      if (newPrice && Number(newPrice) >= 0) {
        try {
          this.triggerLoading();
          this.showSaveIndicator();

          //Create the related attr
          const related = cloneDeep(this.relatedRows);
          console.log("this.row?.styleId", this.row?.styleId);
          const updatedRelated = related.map((r) => {
            if (r.styleId === this.row?.styleId) {
              return { ...this.row, customPrice: newPrice };
            } else {
              return r;
            }
          });
          console.log({ updatedRelated });
          const payload = {
            custom_catalog_product_id: this.product.id,
            related: updatedRelated,
          };

          await this.updatePlaybookItem(payload);
        } catch (error) {
          console.log(error);
        } finally {
          this.endLoading();
        }
      }
    }, 500),
  },

  props: {
    row: {
      type: Object,
    },
    relatedRows: {
      type: Array,
    },
    index: {
      type: Number,
    },
    isPlaceholderPage: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
    },
    productIsEditable: {
      type: Boolean,
    },
    pageId: {
      type: Number,
    },
    columnIndex: {
      type: Number,
    },
    itemIndex: {
      type: Number,
    },
    sportName: {
      type: String,
    },
    showPrice: {
    },
    layoutIndex: {
      type: Number,
    },
    hasManyRows: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  display: flex;
  justify-content: space-between;
  padding: 0.5em !important;
  padding-left: 0.75em !important;
  padding-right: 1em !important;
  background-color: white;
  border-radius: 6px;
  font-size: 0.9em;
  height: 3em;

  &.table-item-small {
    padding: 0 0.75em !important;
    height: 2.5em;
  }

  &:nth-child(odd) {
    background-color: $grey-lightest;
  }

  p,
  div {
    width: 18%;
    text-transform: capitalize;
    display: flex;
    align-items: center;

    &.code,
    &.gender,
    &.size {
      width: 15%;
    }

    .tooltip-container {
      position: relative;
      margin-left: 0.5em;
      .tooltip-info {
        background: $dark;
        position: absolute;
        color: $white;
        box-shadow: 0px 0px 17px -8px #00000078;
        width: max-content;
        left: -65%;
        bottom: -2.3rem;
        padding: 0.5rem;
        border-radius: 6px;
        z-index: 10;
        opacity: 0;
        transition: opacity 0.1s ease-in;
        pointer-events: none;
      }

      &:hover {
        .tooltip-info {
          opacity: 1;
        }
      }
    }
    img {
      height: 1.25rem;
      width: 1.25rem;
    }

    &.price,
    &.msrp {
      width: 30%;
    }
  }

  .long-size-row {
    width: 50% !important;
  }

  .price {
    position: relative;
    input {
      width: 100%;
      text-align: end;
      border-radius: 6px;
      border: 1px solid $grey-light;
      padding: 0.25rem 0.5rem;
      /* Chrome, Safari, Edge, Opera */
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      &[type="number"] {
        -moz-appearance: textfield;
      }
    }
    .dollar-sign {
      color: $grey-dark;
      position: absolute;
      left: -0.8em;
      z-index: 1;
    }

    &.editable {
      .dollar-sign {
        left: 0.5em;
        top: 0.35em;
        z-index: 1;
      }
    }
  }

  .msrp {
    color: $grey-dark;
  }
}
</style>
